import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
import './error.less';
export default {
  name: 'backBtnGroup',
  data: function data() {
    return {
      second: 5,
      timer: null
    };
  },
  methods: {
    backHome: function backHome() {
      this.$router.replace({
        name: this.$config.homeName
      });
    },
    backPrev: function backPrev() {
      this.$router.go(-1);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.timer = setInterval(function () {
      if (_this.second === 0) _this.backPrev();else _this.second--;
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  }
};